<div class="row">
  <div class="col-6">
    <h2>{{ buttonTitle }}</h2>
  </div>
  <div class="col-sm-6">
    <button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onBack()">
      Back
    </button>
    <button type="submit" (click)="onSubmit()" style="float: right; margin-right: 20px" class="btn btn-primary px-4">
      Save
    </button>
  </div>
</div>

<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body style="position: relative">
      <form [formGroup]="storeForm">
        <div class="row">
          <div class="col-sm-6">
            <label class="form-label">Name</label>
            <input class="form-control" placeholder="Enter Name" formControlName="storeName" nbInput />
          </div>

          <div class="col-sm-6">
            <label class="form-label">Address</label>

            <input #ngxPlaces="ngx-places" class="form-control searchinput" type="text" formControlName="address"
              nbInput ngx-gp-autocomplete (onAddressChange)="selectAddress($event)" />
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">PCname</label>
            <input class="form-control" placeholder="Enter PC Name" formControlName="PCname" nbInput />
          </div>

          <div class="col-sm-6">
            <label class="form-label">Equipment Comment</label>
            <textarea class="form-control" placeholder="Enter Equipment Comment" formControlName="EquipmentComment" 
                      nbInput rows="2"></textarea>
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">Internal BackendKey</label>
            <input class="form-control" placeholder="Enter Internal BackendKey" formControlName="internalBackendKey"
              nbInput />
          </div>

          <div class="col-sm-6">
            <label class="form-label">Internal BackendUrl</label>
            <input type="email" class="form-control" placeholder="Enter Internal BackendUrl"
              formControlName="internalBackendUrl" nbInput />
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">Longitude</label>
            <input class="form-control" placeholder="Enter Longitude" formControlName="longitude" nbInput
              oninput="this.value = this.value.replace(/[^0-9.]/g, '');" />
          </div>
          <div class="col-sm-6">
            <label class="form-label">Latitude</label>
            <input class="form-control" placeholder="Enter Latitude" formControlName="latitude" nbInput
              oninput="this.value = this.value.replace(/[^0-9.]/g, '');" />
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">Visible</label>
            <ng-select formControlName="isVisible" placeholder="Enter Visiablility">
              <ng-option *ngFor="let data of isVisible" [value]="data.value">{{
                data.name
                }}</ng-option>
            </ng-select>
          </div>

          <div class="col-sm-6">
            <label class="form-label">Geofence Check</label>
            <ng-select formControlName="geofenceCheck" placeholder="Enter Geofence Check">
              <ng-option *ngFor="let data of geoCheck" [value]="data.value">{{
                data.name
                }}</ng-option>
            </ng-select>
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">Status</label>
            <ng-select formControlName="status" placeholder="Status">
              <ng-option *ngFor="let status of data" [value]="status.status">{{
                status.name
                }}</ng-option>
            </ng-select>
          </div>
          <div class="col-sm-6">
            <label class="form-label">Age Limit</label>
            <input class="form-control" placeholder="Enter Age Limit" formControlName="ageLimit" nbInput
              oninput="this.value = this.value.replace(/[^0-9]/g, '').substring(0, 3);" />
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">Age Verification</label>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <nb-toggle formControlName="isAgeVerification"  class="mr-2"></nb-toggle>
              </div>
          </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">Door Opening</label>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <nb-toggle formControlName="isDoorOpening" class="mr-2"></nb-toggle>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">NFC Reader Enabled</label>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <nb-toggle formControlName="isNfcReaderEnabled" class="mr-2"></nb-toggle>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">Ecommerce Enabled</label>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <nb-toggle formControlName="isEcommerceEnabled" class="mr-2" status="success"></nb-toggle>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">POS System Enabled</label>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <nb-toggle formControlName="posEnabled" class="mr-2" status="info"></nb-toggle>
              </div>
            </div>
          </div>
        </div>

        <!-- Signup Settings Section -->
        <div class="row" style="margin-top: 30px;">
          <div class="col-12">
            <h5>Signup Settings</h5>
            <hr>
            <p class="text-muted small mb-0">SMS and email signup validation are configured globally on the Dashboard.</p>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-8">
                <label class="form-label">Require Veriff for non-Danish customers</label>
                <small class="text-muted d-block">Customers without a Danish CPR number must complete Veriff identity verification before purchasing alcohol or tobacco products.</small>
              </div>
              <div class="col-sm-4 d-flex justify-content-end">
                <nb-toggle formControlName="requireVeriffForNonDanish" class="mr-2"></nb-toggle>
              </div>
            </div>
          </div>
        </div>

        <!-- Financial Settings Section -->
        <div class="row" style="margin-top: 30px;">
          <div class="col-12">
            <h5>Financial Settings</h5>
            <hr>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <!-- Commission Rate - General Admins Only -->
          <div class="col-sm-6">
            <label class="form-label">
              Commission Rate (%)
              <i class="fa fa-info-circle" 
                 nbTooltip="Percentage fee Hit2Open takes on card terminal transactions"
                 nbTooltipPlacement="right"></i>
            </label>
            <input 
              class="form-control" 
              type="number" 
              min="0" 
              max="100" 
              step="0.1"
              placeholder="5.0" 
              formControlName="commissionRate" 
              [readonly]="!isGeneralAdmin"
              [disabled]="!isGeneralAdmin"
              nbInput />
            <small *ngIf="!isGeneralAdmin" class="text-muted">
              Only general administrators can edit this field
            </small>
          </div>

          <!-- Viva Merchant ID - Both Admins -->
          <div class="col-sm-6">
            <label class="form-label">
              Viva Merchant ID (Optional)
              <i class="fa fa-info-circle" 
                 nbTooltip="Merchant ID provided by Viva for ISV payments"
                 nbTooltipPlacement="right"></i>
            </label>
            <input 
              class="form-control" 
              type="text"
              placeholder="viva_merchant_abc123" 
              formControlName="vivaMerchantId" 
              nbInput />
            <small class="text-muted">
              Required for card terminal payments via Viva ISV
            </small>
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-sm-6">
            <label class="form-label">Time Zone</label>
            <input class="form-control" placeholder="Enter Time Zone" formControlName="timeZone" nbInput readonly />
          </div>
          <div class="col-sm-6">
            <div class="col-sm-2">
              <label>Image</label><br />
              <div class="imageWidth">
                <label class="file">
                  <input type="file" name="image" accept="image/*" id="exampleInputFile"
                    (change)="updateImage($event, 'Image')" formControlName="image" />
                  <span *ngIf="!imageSrc || imageSrc== null"><img src="assets/images/plusnew.png" height="50" /></span>
                  <span *ngIf="imageSrc"><img src="{{ imageSrc }}" height="50" /></span>
                  <i *ngIf="imageSrc" (change)="updateImage($event, 1)" class=" image fa-regular fa-pen-to-square"></i>
                  <!-- <i *ngIf="imageSrc" (click)="removeImage('Image')" class="fa-solid fa-trash-can"></i> -->
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="col-sm-2 mt-3">
              <label>Logo</label><br />
              <div class="imageWidth">
                <label class="file">
                  <input type="file" name="logo" accept="image/*" id="exampleInputFile"
                    (change)="updateImage($event, 'Logo')" formControlName="logo" />
                  <span *ngIf="!logoImg || logoImg==null"><img src="assets/images/plusnew.png" height="50" /></span>
                  <span *ngIf="logoImg"><img src="{{ logoImg }}" height="50" /></span>
                  <span> </span>
                  <i *ngIf="logoImg" (change)="updateImage($event, 1)" class="logo fa-regular fa-pen-to-square"></i>
                  <!-- <i *ngIf="logoImg" (click)="removeImage('Logo')" class="fa-solid fa-trash-can"></i> -->
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </nb-card-body>
  </nb-card>
</div>

<!-- POS Settings — Reasons -->
<div *ngIf="id" class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-header>
      <h5 style="margin: 0">POS Settings — Reasons</h5>
      <small class="text-muted">Configure reason options shown to POS clerks</small>
    </nb-card-header>
    <nb-card-body>
      <app-pos-reasons
        [storeId]="id"
        [posReasons]="storePosReasons">
      </app-pos-reasons>
    </nb-card-body>
  </nb-card>
</div>

<!-- API Key Management Section -->
<div *ngIf="id" class="col-12">
  <app-api-key-manager [storeId]="id"></app-api-key-manager>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>